<script>
    import { navigate, link } from "svelte-routing";

    export let id;
    export let name;
    export let title_img;

    let random = Math.random()*360;

    function open (event) {
        navigate("/personen/"+id);
    }
</script>

<!-- <a use:link href="/personen/{id}" class="thumbnail" draggable="false" disabled={dragging}>
    <div class="img-wrapper" style="background-image: url('/images/personen/{title_img}')"></div>
    <div class="overlay"></div>
    <span class="more">{name??"Unbekannt"} {dragging}</span>
</a> -->

<button on:mouseup={open} class="thumbnail" draggable="false">
    <div class="img-wrapper" style="background-image: url('/images/personen/{title_img}')"></div>
    <div class="overlay"></div>
    <span class="more">{name??"Unbekannt"}</span>
</button>

<style>
    .thumbnail {
        display: block;
        width: 100%;
        /* height: 100%; */
        box-sizing: border-box;
        padding-top: 70%;
        color: white;
        position: relative;
        text-align: center;
        border-radius: 0.6rem;
        overflow: hidden;
        background-color: #242424;
    }

    .img-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .name {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: rgb(0,0,0);
        background: linear-gradient(180deg, #1a1a1acc 0%, rgba(0,0,0,0) 100%);
        /* text-shadow: 0 0 4px black; */
    }

    .more {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        /* background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
        text-shadow: 0 0 4px black; */
        /* opacity: 0.8; */
    }

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
    }
</style>